import {
  PieChartOutlined,
  FileImageOutlined,
  DatabaseOutlined,
  UserOutlined,
  DragOutlined,
  CreditCardOutlined,
  AimOutlined,
  FileSearchOutlined,
} from "@ant-design/icons";
import {
  AccountBox,
  ContactMail,
  ContentPaste,
  DocumentScanner,
} from "@mui/icons-material";

export const sidebarMapping = {
  kyc_dashboard: [
    {
      route: "/customers/dashboard",
      icon: <PieChartOutlined />,
      name: "Dashboard",
    },
    {
      route: "/customers",
      icon: <UserOutlined />,
      name: "Customer database",
    },
    {
      type: "submenu",
      route: "labeling-group",
      icon: <DragOutlined />,
      name: "Labeling",
      children: [
        {
          route: "/customers/select/labeling",
          icon: <FileImageOutlined />,
          name: "Bulk Labeling",
        },
        {
          route: "/customers/labeling",
          icon: <DragOutlined />,
          name: "Labeling",
        },
        {
          route: "/customers/labeling/cropped",
          icon: <DragOutlined />,
          name: "Cropped Labeling",
        },
      ],
    },
  ],
  sign_detection: [
    {
      route: "/validation/parking-signs-select",
      icon: <FileImageOutlined />,
      name: "Signs select",
    },
    {
      route: "/validation/parking-signs",
      icon: <DatabaseOutlined />,
      name: "Signs annotate",
    },
  ],
  credit_risk: [
    {
      route: "/credit-risk",
      icon: <AimOutlined />,
      name: "Train Model",
    },
    {
      route: "/credit-risk/score",
      icon: <CreditCardOutlined />,
      name: "Credit Score",
    },
  ],
  invoices: [
    {
      route: "/invoices",
      icon: <FileSearchOutlined />,
      name: "Invoices",
    },
    // {
    //   route: "/add-invoices",
    //   icon: <FileAddOutlined />,
    //   name: "Add Invoices",
    // },
  ],
  blue_zinc: [
    {
      route: "/blue-zinc/my-details",
      icon: <AccountBox />,
      name: "My Details",
    },
    {
      route: "/blue-zinc/my-application",
      icon: <ContentPaste />,
      name: "My Application",
    },
    {
      route: "/blue-zinc/my-documents",
      icon: <DocumentScanner />,
      name: "My Documents",
    },
    {
      route: "/blue-zinc/my-statements",
      icon: <ContactMail />,
      name: "My Statements",
    },
    {
      route: "/scheduler/dashboard",
      icon: <AccountBox />,
      name: "Dashboard",
    },
    // {
    //   route: "/scheduler/commissions",
    //   icon: <AccountBox />,
    //   name: "Commissions",
    // },
    {
      route: "/scheduler/schedule-meeting",
      icon: <AccountBox />,
      name: "Schedule Appointment",
    },
    {
      route: "/onboard",
      icon: <PieChartOutlined />,
      name: "Client",
    },
    // {
    //   route: "/onboard/commission",
    //   icon: <PieChartOutlined />,
    //   name: "Commission",
    // },
  ],
  schedule_meet: [
    {
      route: "/scheduler/dashboard",
      icon: <AccountBox />,
      name: "Dashboard",
    },
    {
      route: "/scheduler/commissions",
      icon: <AccountBox />,
      name: "Commissions",
    },
    {
      route: "/scheduler/schedule-meeting",
      icon: <AccountBox />,
      name: "Schedule Appointment",
    },
  ],
  onboard: [
    {
      route: "/onboard",
      icon: <PieChartOutlined />,
      name: "Client",
    },
    {
      route: "/onboard/commission",
      icon: <PieChartOutlined />,
      name: "Commission",
    },
  ],
  meeting: [
    {
      type: "submenu",
      route: "/client",
      icon: <PieChartOutlined />,
      name: "Client Management",
      children: [
        {
          route: "/home",
          icon: <PieChartOutlined />,
          name: "Client",
        },
        {
          route: "/contacts",
          icon: <PieChartOutlined />,
          name: "Contacts",
        },
      ],
    },
    {
      route: "/meetings",
      icon: <PieChartOutlined />,
      name: "Meetings",
    },
    // {
    //   route: "/meeting-scheduler/new-meeting",
    //   icon: <PieChartOutlined />,
    //   name: "New Meeting",
    // },
    // {
    //   route: "/meeting-scheduler/send-email",
    //   icon: <PieChartOutlined />,
    //   name: "Send Email",
    // },
    // {
    //   route: "/meeting-scheduler/e-sign",
    //   icon: <PieChartOutlined />,
    //   name: "E-Sign",
    // },
    // {
    //   route: "/meeting-scheduler/meetings/:meetingId",
    //   icon: <PieChartOutlined />,
    //   name: "File Notes",
    // },
    // {
    //   route: "/meeting-scheduler/client/graph",
    //   icon: <PieChartOutlined />,
    //   name: "Client Graph",
    // },
    // {
    //   route: "/meeting-scheduler/fact",
    //   icon: <PieChartOutlined />,
    //   name: "Fact Find",
    // },
    // {
    //   route: "/meeting-scheduler/client/cashflow",
    //   icon: <PieChartOutlined />,
    //   name: "Cashflow Modelling",
    // },
  ],

};
